import $ from 'jquery'
import { lockBody, unlockBody } from '../functions'

$(document).click(function(event) {
  if (!$(event.target).is('.filters-responsive *, .filter-toggle  ')) {
    closeFilter()
  }
});

$('.filters label').on('click', function (e) {
  const radio = $(this).find('input')
  if (radio.attr('type') !== 'radio') {
    return
  }

  e.preventDefault()

  if (radio.is(':checked')) {
    radio.prop('checked', false).trigger('change')
  } else {
    radio.prop('checked', true).trigger('change')
  }
})

const openFilter = () => {
  //lockBody()
  const body = document.body
  body.classList.add('filter-active')
}

const closeFilter = () => {
  //unlockBody()
  const body = document.body
  body.classList.remove('filter-active')
}

const toggleFilter = () => {
  const body = document.body

  if (body.classList.contains('filter-active')) {
    closeFilter()
  } else {
    openFilter()
  }
}

$('.filter-toggle').on('click', toggleFilter)

$('.filters-responsive').on('click', function (e) {
  if (e.target === e.currentTarget) {
    closeFilter()
  }
})

$('.filter__more').on('click', function () {
  const button = $(this)
  const button_parent = button.parents('.filter__container')
  const numberItems = button_parent.attr('data-number-items')

  if (button_parent.hasClass('filter__container--active')) {
    button_parent.removeAttr('style')
  } else {
    var maxHeight = numberItems * 36 + 20
    button_parent.css('max-height', maxHeight + 'px')
  }

  var text = button_parent.attr('data-text')
  var buttonContent = button.html()
  button.html(text)
  button_parent.attr('data-text', buttonContent)

  button_parent.toggleClass('filter__container--active')
})

const filters = document.querySelector('.filters-responsive');

window.addEventListener('load', () => {
  if (window.matchMedia('(min-width: 992px)').matches && filters) {
    setTimeout(() => {
      openFilter()
    }, 500);
  }
});
